import React from 'react'
import ProjectFinder from '../../components/projectFinder/ProjectFinder'
import ProjectBrowser from '../../components/projectBrowser/ProjectBrowser'
import ProjectNavbar from '../../components/projectNavbar/ProjectNavbar'
import TopNavbar from '../../components/topNavbar/TopNavbar'
import { connect } from 'react-redux'
import Div100vh from 'react-div-100vh'

class MainPage extends React.Component {
  constructor(props) {
    super(props);

    document.body.classList.add('project-viewer');

    this.state = {
      show: this.props.reviewId!=null ? false : true
    };
  }

  showHide = () => {
    this.setState({
      show: !this.state.show
    })
  }

  render() {
    return (
      <Div100vh id="theMainPage">
        <TopNavbar />
        <section id="theContent" className={`${this.state.show ? 'theEastSideShow' : ''}`}>
          <button type="button" className={`btn nav-toggle ${this.state.show ? 'd-none' : 'd-block'}`} onClick={this.showHide} data-keyboard="true">
            <span className="sr-only">Show navigation</span>
          </button>
          <div id="theEastSide" className={`collapse ${this.state.show ? 'show' : ''}`}>
            <div className="d-flex border-bottom"> 
              <ProjectFinder />
              <button type="button" className={`btn close nav-close ${this.state.show ? 'd-block' : 'd-none'}`} onClick={this.showHide} data-keyboard="true">
                <span className="sr-only">Hide navigation</span>
              </button>
            </div>
            <ProjectBrowser showHide={this.state.show} />
          </div>
          <div id="theMainContent">
            <ProjectNavbar show={this.state.show} />
          </div>
        
        </section>
        <div class="fixed-bottom navbar navbar-viewer"><h4 className='text-white  mt-3 text-right'>Icons provided by <a className='text-white' href='https://icons8.com/'>Icons8</a></h4></div>
      </Div100vh>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.requestModelDataReducer.data,
  reviewId: state.getPersonalHubReducer.reviewId,
})

export default connect(mapStateToProps)(MainPage);